import type { MaybeRef } from "vue"
import type { ServerResponse } from "@/http"
import type { IUserHostInviteeResponse } from "@/models/userHostInvitee"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { axios } from "@/axios"
import { UserHostInvitee } from "@/models/userHostInvitee"

interface IListCoHostsResponse {
  AllowAddingUsers: boolean
  AllowUpdatingUsers: boolean
  Users: IUserHostInviteeResponse[]
}

interface IListCoHosts {
  allowAddingUsers?: boolean
  allowUpdatingUsers?: boolean
  users?: UserHostInvitee[]
}

export async function listCoHosts(eventVaultId: number): Promise<IListCoHosts> {
  if (!eventVaultId) {
    throw new Error("Missing `eventVaultId` when attempting to list co-hosts. Please ensure `eventVaultId` is provided.")
  }

  const endpoint = `api/${eventVaultId}/users`

  const response = await axios.get<ServerResponse<IListCoHostsResponse>>(endpoint)

  return {
    allowAddingUsers: response.data.Data?.AllowAddingUsers ?? false,
    allowUpdatingUsers: response.data.Data?.AllowUpdatingUsers ?? false,
    users: response.data.Data?.Users?.map(user => UserHostInvitee.fromResponse(user)) ?? [],
  }
}

export const LIST_CO_HOSTS_KEY = "listCoHosts"

export function useListHostInvitees(eventVaultId?: MaybeRef<number | undefined>) {
  return useQuery({
    queryKey: [LIST_CO_HOSTS_KEY, eventVaultId],
    queryFn: () => listCoHosts(toValue(eventVaultId)!),
    enabled: !!toValue(eventVaultId),
  })
}
